import { getNextOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import { SELLER_DISCOUNTS_ENDED_STREAM } from '../../../constants';
import { getItemsPerFetch } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { PapiRequestStudioDiscountsInit, PapiStudioDiscountsInit } from '@wix/da-papi-types';
import { fetchStreamContents } from '@wix/da-shared-react/pkg/Stream/helpers';
import { select } from 'redux-saga/effects';
import { DiscountsSubsection } from '../../types/store';

export function* handleFetchNextSellerDiscountsEnded() {
  const { offset, limit } = yield select(state => ({
    offset: getNextOffset(state, SELLER_DISCOUNTS_ENDED_STREAM.streamId),
    limit: getItemsPerFetch(state, SELLER_DISCOUNTS_ENDED_STREAM.streamId),
  }));

  yield fetchStreamContents<PapiRequestStudioDiscountsInit, PapiStudioDiscountsInit>({
    streamId: SELLER_DISCOUNTS_ENDED_STREAM.streamId,
    params: {
      filter: DiscountsSubsection.Ended,
      offset,
      limit,
    },
    url: 'studio/discounts/init',
    papiProject: 'studio',
    getStreamData: result => ({
      hasMore: Boolean(result.hasMore),
      items: result.results as any,
      nextOffset: result.nextOffset ?? undefined,
    }),
  });
}
